/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Shift_Event_ForwardInputs */

const en_shortcut_keys_name_shift_event_forward = /** @type {(inputs: Shortcut_Keys_Name_Shift_Event_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shift Event Forward`)
};

const fr_shortcut_keys_name_shift_event_forward = /** @type {(inputs: Shortcut_Keys_Name_Shift_Event_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decaler l'evenement vers l'avant`)
};

const de_shortcut_keys_name_shift_event_forward = /** @type {(inputs: Shortcut_Keys_Name_Shift_Event_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis vorwärts verschieben`)
};

const it_shortcut_keys_name_shift_event_forward = /** @type {(inputs: Shortcut_Keys_Name_Shift_Event_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sposta evento in avanti`)
};

const ru_shortcut_keys_name_shift_event_forward = /** @type {(inputs: Shortcut_Keys_Name_Shift_Event_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сдвиг события вперед`)
};

const es_shortcut_keys_name_shift_event_forward = /** @type {(inputs: Shortcut_Keys_Name_Shift_Event_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplazar evento hacia adelante`)
};

const zh_cn2_shortcut_keys_name_shift_event_forward = /** @type {(inputs: Shortcut_Keys_Name_Shift_Event_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向前移动事件`)
};

const ja_shortcut_keys_name_shift_event_forward = /** @type {(inputs: Shortcut_Keys_Name_Shift_Event_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントを前へシフト`)
};

const hi_shortcut_keys_name_shift_event_forward = /** @type {(inputs: Shortcut_Keys_Name_Shift_Event_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घटना को आगे बढ़ाएं`)
};

const pt_pt2_shortcut_keys_name_shift_event_forward = /** @type {(inputs: Shortcut_Keys_Name_Shift_Event_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deslocar evento para a frente`)
};

/**
* | output |
* | --- |
* | "Shift Event Forward" |
*
* @param {Shortcut_Keys_Name_Shift_Event_ForwardInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_shift_event_forward = /** @type {((inputs?: Shortcut_Keys_Name_Shift_Event_ForwardInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Shift_Event_ForwardInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_shift_event_forward(inputs)
	if (locale === "de") return de_shortcut_keys_name_shift_event_forward(inputs)
	if (locale === "it") return it_shortcut_keys_name_shift_event_forward(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_shift_event_forward(inputs)
	if (locale === "es") return es_shortcut_keys_name_shift_event_forward(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_shift_event_forward(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_shift_event_forward(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_shift_event_forward(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_shift_event_forward(inputs)
	return en_shortcut_keys_name_shift_event_forward(inputs)
});